import React, { useEffect, useState, useContext } from "react";
import HeaderProfile from '../Components/HeaderProfile'
import { AuthContext } from "../Routes/AuthProvider"
import { GetProfileDetails } from "../Services/API";
import { UpdatePhoneNumber } from "../Services/ProfileUpdateApi";
import { UpdatePersonalEmailId } from "../Services/ProfileUpdateApi";

import FrequentFlyer from '../Settings/FrequentFlyer';

const Myprofile = () => {
    const { name, userName } = useContext(AuthContext);

    const [profileData, setProfileData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [enquiryMessage, setEnquiryMessage] = useState("");
    const [enquiryStatus, setEnquiryStatus] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [error, setError] = useState("");
    const [phone, setPhone] = useState("");
    const [personalEmail, setPersonalEmail] = useState("");  


    const [arrivalSuggestions, setArrivalSuggestions] = useState([]);

    useEffect(() => {
        if (userName) {
            fetchProfileData(userName);
        } else {
            console.warn("Missing userName");
        }
    }, [userName]);

    const fetchProfileData = async (userName) => {
        try {
            setLoading(true);
            setError("");
            const agentProfileResponse = await GetProfileDetails(userName);
            setProfileData(agentProfileResponse.data.corporateDetails);
            //console.log("agentProfileResponse:", agentProfileResponse.data.corporateDetails);
        } catch (err) {
            setError("Failed to load flight details. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        setPhone(e.target.value);
    };

    const handleEmailChange = (e) => {
        setPersonalEmail(e.target.value);
    };

    const UpdatePhoneNoRequest = async () => {
        let newErrors = {};

        const PhoneNumber = phone.replace(/\s+/g, "");
        const phoneRegex = /^[6-9]\d{9}$/;

        if (!PhoneNumber) {
            newErrors.phone = "Phone number is required";
        } else if (!phoneRegex.test(PhoneNumber)) {
            newErrors.phone = "Enter a valid 10-digit mobile number";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setErrors({});

        try {
            const result = await UpdatePhoneNumber(userName, PhoneNumber);
            alert(result.message);
            if (result.success) {
                setEnquiryMessage(result.message);
                setEnquiryStatus(true);
                window.location.reload();
            } else {
                setEnquiryMessage(result.message);
                setEnquiryStatus(false);
            }

            setShowPopup(true);
        } catch (error) {
            alert("Failed to update phone number");
        }
    };

    const [flightlist, setFlightlist] = useState({

        airlineName: "",
    });

    const UpdateEmailRequest = async () => {
        let newErrors = {};

        const email = personalEmail?.trim().toLowerCase();

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

        if (!email) {
            newErrors.personalEmail = "Email address is required";
        } else if (!emailRegex.test(email)) {
            newErrors.personalEmail = "Enter a valid email address";
        }

        // Stop API call if validation fails
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setErrors({});

        try {
            const result = await UpdatePersonalEmailId(profileData?.userId, email);
            alert(result.message);
            if (result.success) {
                window.location.reload();
            }
            setEnquiryMessage(result.message);
            setEnquiryStatus(!!result.success);
            setShowPopup(true);
        } catch (error) {
            alert("Failed to update email");
        }
    };
    // --- HANDLE handleAirlineChange ---
   


    return (
        <>
            {loading && (
                <p class="text-center load"><span class="loader"></span></p>
            )}
            <HeaderProfile></HeaderProfile>
            <div className="toolbar py-2" id="kt_toolbar">
                <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1 flex-shrink-0 me-5">
                        <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                            <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Settings</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li className="breadcrumb-item">
                                    <a href="/Settings/Myprofile" className="text-muted text-hover-primary">My Profile</a>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div class="d-flex align-items-center flex-wrap">
                        <div class="flex-shrink-0">
                            <ul class="nav" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a href='/settings'>
                                        <img src='/assets/images/back.png' className="imgBack" /> </a>
                                </li>


                            </ul>
                        </div>


                    </div>

                </div>
            </div>

            <section className='wraper'>
                <div className='box_shadow mt-14'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h3 className='headings'>Personal Information</h3>
                        </div>
                        <div className='col-lg-4 text-center'>
                            <div class="complny_log">
                                <i className='fa fa-edit editer' data-bs-toggle="modal" data-bs-target="#profileChangeModal"></i>
                                <img alt="" src="/assets/images/profile.png" />
                            </div>
                        </div>
                        <div className='col-md-8'>
                            <div class="d-flex mb-3">
                                <div class="labl">Full Name </div>
                                <div class="labl_detls">{profileData?.title} {profileData?.firstName} {profileData?.lastName} </div>
                            </div>
                            <div class="d-flex mb-3">
                                <div class="labl">Phone Number </div>
                                <div class="labl_detls">{profileData?.phoneNumber} <i className='fa fa-edit edit' data-bs-toggle="modal" data-bs-target="#PhoneChangeModal"></i> </div>
                            </div>
                            <div class="d-flex mb-3">
                                <div class="labl">Email ID </div>
                                <div class="labl_detls">{profileData?.email}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div class="labl">Nationality </div>
                                <div class="labl_detls">{profileData?.nationality}</div>
                            </div>
                            <div class="d-flex mb-3">
                                <div class="labl">Personal Email ID </div>
                                <div class="labl_detls">{profileData?.personalEmail}<i className='fa fa-edit edit' data-bs-toggle="modal" data-bs-target="#EmailChangeModal"></i></div>
                            </div>
                            {/* <div class="d-flex mb-3">
                                <div class="labl">User Language </div>
                                <div class="labl_detls">English/Hindi </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className='box_shadow mt-3'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <h3 className='headings'>Organization Profile</h3>
                        </div>
                        <div class="col-md-4">
                            <div class="d-flex mb-3">
                                <div class="labl">Billing Entity </div>
                                <div class="labl_detls">{profileData?.CorporateId} </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="d-flex mb-3">
                                <div class="labl">Employee ID </div>
                                <div class="labl_detls">{profileData?.employeeId} </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="d-flex mb-3">
                                <div class="labl">Designation </div>
                                <div class="labl_detls">{profileData?.designationName} </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="d-flex mb-3">
                                <div class="labl">Band </div>
                                <div class="labl_detls"> {profileData?.bandName}</div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="d-flex mb-3">
                                <div class="labl">Date of Joining </div>
                                <div class="labl_detls"> {profileData?.dateOfJoining}</div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="d-flex mb-3">
                                <div class="labl">Work Location </div>
                                <div class="labl_detls">{profileData?.corporateId} </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="d-flex mb-3">
                                <div class="labl">Department </div>
                                <div class="labl_detls">{profileData?.departmentName} </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="d-flex mb-3">
                                <div class="labl">Cost Center </div>
                                <div class="labl_detls">{profileData?.costCenterName} </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="d-flex mb-3">
                                <div class="labl">Date of Birth </div>
                                <div class="labl_detls"> {profileData?.dob}</div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="d-flex mb-3">
                                <div class="labl">Reporting Manager </div>
                                <div class="labl_detls"> {profileData?.reportingManagerName}</div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="d-flex mb-3">
                                <div class="labl">Role </div>
                                <div class="labl_detls">{profileData?.role} </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="d-flex mb-3">
                                <div class="labl">System Intrgration Ref No </div>
                                <div class="labl_detls"> {profileData?.userId}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='box_shadow mt-3 mb-15'>
                  <FrequentFlyer userName={userName} />
                </div>
            </section>

            <div class="modal fade" id="PhoneChangeModal">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">Phone Number</h4>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div class="modal-body">
                            <div className='row'>
                                <div class="col-md-5 mb-3">
                                    <label className='required'>Old Phone Number</label>
                                    <input class="form-control form-control-solid" type="text" name="" value={profileData?.phoneNumber} readOnly />
                                </div>

                                {/* <div class="col-md-5 mb-3">
                                    <label className='required'>New Phone Number</label>
                                    <input class="form-control form-control-solid" type="text" name="phone"
                                        value={phone}
                                        maxLength={10}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, ""); // allow only digits
                                            if (value.length <= 10) {
                                                setPhone(value);
                                            }
                                        }}
                                    />
                                </div> */}
                                <div className="col-md-5 mb-3">
                                    <label className="required">New Phone Number</label>

                                    <input
                                        className={`form-control form-control-solid ${errors?.phone ? "is-invalid" : ""}`}
                                        type="text"
                                        name="phone"
                                        value={phone}
                                        maxLength={10}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, "");
                                            if (value.length <= 10) {
                                                setPhone(value);
                                            }

                                            if (errors?.phone) {
                                                setErrors({ ...errors, phone: "" });
                                            }
                                        }}
                                    />

                                    {errors?.phone && (
                                        <div className="invalid-feedback">
                                            {errors.phone}
                                        </div>
                                    )}
                                </div>


                                <div class="col-md-2 mt-6 mb-3 text-end">
                                    <button className='btn btn-primary m-2' onClick={UpdatePhoneNoRequest}>Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="profileChangeModal">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">Profile Picture</h4>
                            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div class="modal-body">
                            <div className='row'>
                                <div class="col-md-5 mb-3">
                                    <label className='required'>Upload Picture</label>
                                    <input class="form-control form-control-solid" type="file" name="" />
                                </div>

                                <div class="col-md-2 mt-6 mb-3 text-end">
                                    <button className='btn btn-primary m-2' onClick={UpdateEmailRequest}>Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="modal fade" id="EmailChangeModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Email Address</h4>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                            ></button>
                        </div>

                        <div className="modal-body">
                            <div className="row">

                                {/* Old Email */}
                                <div className="col-md-5 mb-3">
                                    <label className="required">Old Email ID</label>
                                    <input
                                        className="form-control form-control-solid"
                                        type="email"
                                        value={profileData?.personalEmail || ""}
                                        readOnly
                                    />
                                </div>

                                {/* New Email */}
                                <div className="col-md-5 mb-3">
                                    <label className="required">New Email ID</label>
                                    <input
                                        className={`form-control form-control-solid ${errors?.personalEmail ? "is-invalid" : ""
                                            }`}
                                        type="email"
                                        name="personalEmail"
                                        value={personalEmail}
                                        onChange={handleEmailChange}
                                    />

                                    {errors?.personalEmail && (
                                        <div className="invalid-feedback">
                                            {errors.personalEmail}
                                        </div>
                                    )}
                                </div>

                                {/* Update Button */}
                               <div class="col-md-2 mt-6 mb-3 text-end">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={UpdateEmailRequest}
                                        disabled={
                                            !personalEmail ||
                                            personalEmail.trim().toLowerCase() ===
                                            profileData?.personalEmail?.toLowerCase()
                                        }
                                    >
                                        Update
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

          

        </>
    );
}

export default Myprofile;